var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _setup.regionModel
    ? _c("div", [
        _c(
          "div",
          { attrs: { id: "navigationPlaceholder" } },
          [
            _c(_setup.WorkspaceNavigation, {
              attrs: {
                workspaceId: _vm.$route.params.id,
                workspaceName: "Workspace",
              },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "container-fluid",
            staticStyle: { "margin-top": "50px" },
          },
          [
            _setup.inputSubMenu == "SendEmail"
              ? _c("div", [
                  _c(
                    "div",
                    {
                      staticClass: "modal d-block",
                      attrs: { tabindex: "-1", role: "dialog" },
                    },
                    [
                      _c("div", { staticClass: "modal-dialog" }, [
                        _c("div", { staticClass: "modal-content" }, [
                          _c("div", { staticClass: "modal-header" }, [
                            _c("h3", { attrs: { id: "myModalLabel" } }, [
                              _vm._v("Send email"),
                            ]),
                            _vm._v(" "),
                            _c(
                              "button",
                              {
                                staticClass: "close",
                                attrs: {
                                  type: "button",
                                  "data-dismiss": "modal",
                                },
                                on: {
                                  click: function ($event) {
                                    _setup.inputSubMenu = null
                                  },
                                },
                              },
                              [_vm._v("×")]
                            ),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "modal-body" }, [
                            _c("div", { staticClass: "form-group" }, [
                              _c(
                                "a",
                                {
                                  attrs: {
                                    "data-toggle": "collapse",
                                    href: "#selectedPeopleEmails",
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                                    Recipients: " +
                                      _vm._s(
                                        _setup.selectedPeopleEmails.length
                                      ) +
                                      "\n                                "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "collapse",
                                  attrs: { id: "selectedPeopleEmails" },
                                },
                                [
                                  _vm._v(
                                    "\n                                    " +
                                      _vm._s(
                                        _setup.selectedPeopleEmails.join(", ")
                                      ) +
                                      "\n                                "
                                  ),
                                ]
                              ),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "form-group" }, [
                              _c("label", [_vm._v("Subject")]),
                              _vm._v(" "),
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _setup.inputSubject,
                                    expression: "inputSubject",
                                  },
                                ],
                                staticClass: "form-control",
                                attrs: { type: "text" },
                                domProps: { value: _setup.inputSubject },
                                on: {
                                  input: function ($event) {
                                    if ($event.target.composing) return
                                    _setup.inputSubject = $event.target.value
                                  },
                                },
                              }),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "form-group" }, [
                              _c("label", [_vm._v("Message")]),
                              _vm._v(" "),
                              _c("textarea", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _setup.inputMessage,
                                    expression: "inputMessage",
                                  },
                                ],
                                staticClass: "form-control",
                                attrs: { rows: "3" },
                                domProps: { value: _setup.inputMessage },
                                on: {
                                  input: function ($event) {
                                    if ($event.target.composing) return
                                    _setup.inputMessage = $event.target.value
                                  },
                                },
                              }),
                            ]),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "form-group form-check" },
                              [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _setup.inputIncludeSurveyLink,
                                      expression: "inputIncludeSurveyLink",
                                    },
                                  ],
                                  staticClass: "form-check-input",
                                  attrs: { type: "checkbox" },
                                  domProps: {
                                    checked: Array.isArray(
                                      _setup.inputIncludeSurveyLink
                                    )
                                      ? _vm._i(
                                          _setup.inputIncludeSurveyLink,
                                          null
                                        ) > -1
                                      : _setup.inputIncludeSurveyLink,
                                  },
                                  on: {
                                    change: function ($event) {
                                      var $$a = _setup.inputIncludeSurveyLink,
                                        $$el = $event.target,
                                        $$c = $$el.checked ? true : false
                                      if (Array.isArray($$a)) {
                                        var $$v = null,
                                          $$i = _vm._i($$a, $$v)
                                        if ($$el.checked) {
                                          $$i < 0 &&
                                            (_setup.inputIncludeSurveyLink =
                                              $$a.concat([$$v]))
                                        } else {
                                          $$i > -1 &&
                                            (_setup.inputIncludeSurveyLink = $$a
                                              .slice(0, $$i)
                                              .concat($$a.slice($$i + 1)))
                                        }
                                      } else {
                                        _setup.inputIncludeSurveyLink = $$c
                                      }
                                    },
                                  },
                                }),
                                _vm._v(" "),
                                _c(
                                  "label",
                                  { staticClass: "form-check-label" },
                                  [_vm._v("Include individual survey link")]
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "form-group form-check" },
                              [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _setup.inputIncludeReportLink,
                                      expression: "inputIncludeReportLink",
                                    },
                                  ],
                                  staticClass: "form-check-input",
                                  attrs: { type: "checkbox" },
                                  domProps: {
                                    checked: Array.isArray(
                                      _setup.inputIncludeReportLink
                                    )
                                      ? _vm._i(
                                          _setup.inputIncludeReportLink,
                                          null
                                        ) > -1
                                      : _setup.inputIncludeReportLink,
                                  },
                                  on: {
                                    change: function ($event) {
                                      var $$a = _setup.inputIncludeReportLink,
                                        $$el = $event.target,
                                        $$c = $$el.checked ? true : false
                                      if (Array.isArray($$a)) {
                                        var $$v = null,
                                          $$i = _vm._i($$a, $$v)
                                        if ($$el.checked) {
                                          $$i < 0 &&
                                            (_setup.inputIncludeReportLink =
                                              $$a.concat([$$v]))
                                        } else {
                                          $$i > -1 &&
                                            (_setup.inputIncludeReportLink = $$a
                                              .slice(0, $$i)
                                              .concat($$a.slice($$i + 1)))
                                        }
                                      } else {
                                        _setup.inputIncludeReportLink = $$c
                                      }
                                    },
                                  },
                                }),
                                _vm._v(" "),
                                _c(
                                  "label",
                                  { staticClass: "form-check-label" },
                                  [_vm._v("Include individual report link")]
                                ),
                              ]
                            ),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "modal-footer" }, [
                            _c(
                              "button",
                              {
                                staticClass: "btn",
                                attrs: { "data-dismiss": "modal" },
                                on: {
                                  click: function ($event) {
                                    _setup.inputSubMenu = null
                                  },
                                },
                              },
                              [_vm._v("Close")]
                            ),
                            _vm._v(" "),
                            _c(
                              "button",
                              {
                                staticClass: "btn btn-primary",
                                attrs: {
                                  disabled:
                                    _setup.inputSubject == null ||
                                    _setup.inputSubject.length < 2 ||
                                    _setup.inputMessage == null ||
                                    _setup.inputMessage.length < 2,
                                },
                                on: {
                                  click: _setup.handleSendIndividualReports,
                                },
                              },
                              [_c("span", [_vm._v("Send")])]
                            ),
                          ]),
                        ]),
                      ]),
                    ]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "modal-backdrop fade show" }),
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-lg-12" }, [
                _setup.regionModel && _setup.regionModel.Name
                  ? _c("div", { staticStyle: { margin: "30px" } }, [
                      _c("h2", [
                        _vm._v(
                          "\n                        Region " +
                            _vm._s(_setup.regionModel.Name) +
                            "\n                        "
                        ),
                        _setup.regionModel.VotingCycle
                          ? _c("span", [
                              _vm._v(
                                "(" +
                                  _vm._s(_setup.regionModel.VotingCycle) +
                                  " "
                              ),
                              _setup.regionModel.VotingCycleStarted
                                ? _c("span", [_vm._v("started")])
                                : _c("span", [_vm._v("stopped")]),
                              _vm._v(")"),
                            ])
                          : _vm._e(),
                      ]),
                      _vm._v(" "),
                      !_setup.inputSubMenu
                        ? _c("div", { staticClass: "row" }, [
                            _c("div", { staticClass: "col-sm-10" }, [
                              _c(
                                "button",
                                {
                                  staticClass: "btn btn-primary",
                                  attrs: { type: "button" },
                                  on: {
                                    click: function ($event) {
                                      _setup.inputSubMenu = "AddPerson"
                                    },
                                  },
                                },
                                [_vm._v("Add person...")]
                              ),
                              _vm._v(" "),
                              _c(
                                "button",
                                {
                                  staticClass: "btn btn-secondary",
                                  attrs: { type: "button" },
                                  on: {
                                    click: function ($event) {
                                      _setup.inputSubMenu = "VotingCycle"
                                    },
                                  },
                                },
                                [_vm._v("Voting cycles...")]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "dropdown d-inline-block" },
                                [
                                  _vm._m(0),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "dropdown-menu",
                                      attrs: {
                                        "aria-labelledby": "dropdownMenuButton",
                                      },
                                    },
                                    [
                                      _c(
                                        "a",
                                        {
                                          directives: [
                                            {
                                              name: "show",
                                              rawName: "v-show",
                                              value:
                                                !_setup.regionModel
                                                  .AnonymousMode,
                                              expression:
                                                "!regionModel.AnonymousMode",
                                            },
                                          ],
                                          staticClass: "dropdown-item",
                                          attrs: { href: "#" },
                                          on: {
                                            click:
                                              _setup.handleEnableAnonymousMode,
                                          },
                                        },
                                        [_vm._v("Enable anonymous mode")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "a",
                                        {
                                          directives: [
                                            {
                                              name: "show",
                                              rawName: "v-show",
                                              value:
                                                _setup.regionModel
                                                  .AnonymousMode,
                                              expression:
                                                "regionModel.AnonymousMode",
                                            },
                                          ],
                                          staticClass: "dropdown-item",
                                          attrs: { href: "#" },
                                          on: {
                                            click:
                                              _setup.handleDisableAnonymousMode,
                                          },
                                        },
                                        [_vm._v("Disable anonymous mode")]
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                            ]),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "col-sm-2",
                                staticStyle: { "text-align": "right" },
                              },
                              [
                                _vm._m(1),
                                _vm._v(" "),
                                _c(
                                  "a",
                                  {
                                    directives: [
                                      {
                                        name: "sanitizedHref",
                                        rawName: "v-sanitizedHref",
                                        value: `/#/rankhr/overallreport/${_setup.regionModel.Id}`,
                                        expression:
                                          "`/#/rankhr/overallreport/${regionModel.Id}`",
                                      },
                                    ],
                                    staticClass: "btn btn-success",
                                    attrs: { role: "button" },
                                  },
                                  [_vm._v("Summary report")]
                                ),
                                _vm._v(" "),
                                _c(
                                  "button",
                                  {
                                    staticClass: "btn btn-secondary",
                                    class: {
                                      "btn-warning":
                                        _setup.inputSelectedPeople.length,
                                    },
                                    attrs: {
                                      role: "button",
                                      disabled:
                                        _setup.inputSelectedPeople.length == 0,
                                    },
                                    on: {
                                      click: function ($event) {
                                        _setup.inputSubMenu = "SendEmail"
                                      },
                                    },
                                  },
                                  [
                                    _setup.inputSelectedPeople.length
                                      ? _c("span", [
                                          _vm._v(
                                            " Send (" +
                                              _vm._s(
                                                _setup.inputSelectedPeople
                                                  .length
                                              ) +
                                              ")"
                                          ),
                                        ])
                                      : _c(
                                          "span",
                                          {
                                            attrs: {
                                              title:
                                                "Please select people from the list to send email with survey or report link",
                                            },
                                          },
                                          [_vm._v("Send")]
                                        ),
                                  ]
                                ),
                              ]
                            ),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _c("br"),
                      _vm._v(" "),
                      _setup.inputSubMenu == "AddPerson"
                        ? _c("form", { staticClass: "form-inline" }, [
                            _c(
                              "div",
                              { staticClass: "form-group mb-2" },
                              [
                                _c("label", { staticClass: "sr-only" }, [
                                  _vm._v("Email address"),
                                ]),
                                _vm._v(" "),
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _setup.inputEmail,
                                      expression: "inputEmail",
                                    },
                                  ],
                                  staticClass: "form-control",
                                  attrs: {
                                    type: "email",
                                    placeholder: "Email",
                                  },
                                  domProps: { value: _setup.inputEmail },
                                  on: {
                                    input: function ($event) {
                                      if ($event.target.composing) return
                                      _setup.inputEmail = $event.target.value
                                    },
                                  },
                                }),
                                _vm._v(" "),
                                _c("ValidationError", {
                                  attrs: {
                                    context: "Person.Email",
                                    errors:
                                      _setup.validationErrorsAddPersonCommandV1,
                                  },
                                }),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "form-group mx-sm-3 mb-2" },
                              [
                                _c("label", { staticClass: "sr-only" }, [
                                  _vm._v("Display name"),
                                ]),
                                _vm._v(" "),
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _setup.inputDisplayName,
                                      expression: "inputDisplayName",
                                    },
                                  ],
                                  staticClass: "form-control",
                                  attrs: {
                                    type: "text",
                                    placeholder: "Display Name",
                                  },
                                  domProps: { value: _setup.inputDisplayName },
                                  on: {
                                    input: function ($event) {
                                      if ($event.target.composing) return
                                      _setup.inputDisplayName =
                                        $event.target.value
                                    },
                                  },
                                }),
                                _vm._v(" "),
                                _c("ValidationError", {
                                  attrs: {
                                    context: "Person.DisplayName",
                                    errors:
                                      _setup.validationErrorsAddPersonCommandV1,
                                  },
                                }),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "form-group mx-sm-3 mb-2" },
                              [
                                _c("label", { staticClass: "sr-only" }, [
                                  _vm._v("Criteria"),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "select",
                                  {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _setup.inputCriteriaName,
                                        expression: "inputCriteriaName",
                                      },
                                    ],
                                    staticClass: "form-control",
                                    on: {
                                      change: function ($event) {
                                        var $$selectedVal =
                                          Array.prototype.filter
                                            .call(
                                              $event.target.options,
                                              function (o) {
                                                return o.selected
                                              }
                                            )
                                            .map(function (o) {
                                              var val =
                                                "_value" in o
                                                  ? o._value
                                                  : o.value
                                              return val
                                            })
                                        _setup.inputCriteriaName = $event.target
                                          .multiple
                                          ? $$selectedVal
                                          : $$selectedVal[0]
                                      },
                                    },
                                  },
                                  [
                                    _c("option", [
                                      _vm._v("All Employees & Managers"),
                                    ]),
                                    _vm._v(" "),
                                    _c("option", { attrs: { disabled: "" } }, [
                                      _vm._v("Individual Contributor"),
                                    ]),
                                    _vm._v(" "),
                                    _c("option", { attrs: { disabled: "" } }, [
                                      _vm._v("Manager"),
                                    ]),
                                    _vm._v(" "),
                                    _c("option", { attrs: { disabled: "" } }, [
                                      _vm._v("Senior Manager"),
                                    ]),
                                  ]
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "form-group mx-sm-3 mb-2" },
                              [
                                _c("label", { staticClass: "sr-only" }, [
                                  _vm._v("Scale"),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "select",
                                  {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _setup.inputScaleName,
                                        expression: "inputScaleName",
                                      },
                                    ],
                                    staticClass: "form-control",
                                    on: {
                                      change: function ($event) {
                                        var $$selectedVal =
                                          Array.prototype.filter
                                            .call(
                                              $event.target.options,
                                              function (o) {
                                                return o.selected
                                              }
                                            )
                                            .map(function (o) {
                                              var val =
                                                "_value" in o
                                                  ? o._value
                                                  : o.value
                                              return val
                                            })
                                        _setup.inputScaleName = $event.target
                                          .multiple
                                          ? $$selectedVal
                                          : $$selectedVal[0]
                                      },
                                    },
                                  },
                                  [_c("option", [_vm._v("Default scale")])]
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "button",
                              {
                                staticClass: "btn btn-primary mb-2",
                                attrs: {
                                  type: "button",
                                  disabled: _setup.invokingAddPersonCommandV1,
                                },
                                on: { click: _setup.handleAddPerson },
                              },
                              [_vm._v("Add person")]
                            ),
                            _vm._v(" "),
                            _c(
                              "svg",
                              {
                                staticClass: "bi bi-x",
                                staticStyle: { "margin-left": "30px" },
                                attrs: {
                                  width: "3em",
                                  height: "3em",
                                  viewBox: "0 0 16 16",
                                  fill: "currentColor",
                                  xmlns: "http://www.w3.org/2000/svg",
                                },
                                on: {
                                  click: function ($event) {
                                    _setup.inputSubMenu = null
                                  },
                                },
                              },
                              [
                                _c("path", {
                                  attrs: {
                                    "fill-rule": "evenodd",
                                    d: "M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z",
                                  },
                                }),
                              ]
                            ),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _setup.inputSubMenu == "EditPerson"
                        ? _c("form", { staticClass: "form-inline" }, [
                            _c(
                              "div",
                              { staticClass: "form-group mb-2" },
                              [
                                _c("label", { staticClass: "sr-only" }, [
                                  _vm._v("Email address"),
                                ]),
                                _vm._v(" "),
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _setup.inputEmail,
                                      expression: "inputEmail",
                                    },
                                  ],
                                  staticClass: "form-control",
                                  attrs: {
                                    type: "email",
                                    placeholder: "Email",
                                  },
                                  domProps: { value: _setup.inputEmail },
                                  on: {
                                    input: function ($event) {
                                      if ($event.target.composing) return
                                      _setup.inputEmail = $event.target.value
                                    },
                                  },
                                }),
                                _vm._v(" "),
                                _c("ValidationError", {
                                  attrs: {
                                    context: "Person.Email",
                                    errors:
                                      _setup.validationErrorsUpdatePersonCommandV1,
                                  },
                                }),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "form-group mx-sm-3 mb-2" },
                              [
                                _c("label", { staticClass: "sr-only" }, [
                                  _vm._v("Display name"),
                                ]),
                                _vm._v(" "),
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _setup.inputDisplayName,
                                      expression: "inputDisplayName",
                                    },
                                  ],
                                  staticClass: "form-control",
                                  attrs: {
                                    type: "text",
                                    placeholder: "Display Name",
                                  },
                                  domProps: { value: _setup.inputDisplayName },
                                  on: {
                                    input: function ($event) {
                                      if ($event.target.composing) return
                                      _setup.inputDisplayName =
                                        $event.target.value
                                    },
                                  },
                                }),
                                _vm._v(" "),
                                _c("ValidationError", {
                                  attrs: {
                                    context: "Person.DisplayName",
                                    errors:
                                      _setup.validationErrorsUpdatePersonCommandV1,
                                  },
                                }),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "form-group mx-sm-3 mb-2" },
                              [
                                _c("label", { staticClass: "sr-only" }, [
                                  _vm._v("Criteria"),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "select",
                                  {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _setup.inputCriteriaName,
                                        expression: "inputCriteriaName",
                                      },
                                    ],
                                    staticClass: "form-control",
                                    on: {
                                      change: function ($event) {
                                        var $$selectedVal =
                                          Array.prototype.filter
                                            .call(
                                              $event.target.options,
                                              function (o) {
                                                return o.selected
                                              }
                                            )
                                            .map(function (o) {
                                              var val =
                                                "_value" in o
                                                  ? o._value
                                                  : o.value
                                              return val
                                            })
                                        _setup.inputCriteriaName = $event.target
                                          .multiple
                                          ? $$selectedVal
                                          : $$selectedVal[0]
                                      },
                                    },
                                  },
                                  [
                                    _c("option", [
                                      _vm._v("All Employees & Managers"),
                                    ]),
                                    _vm._v(" "),
                                    _c("option", { attrs: { disabled: "" } }, [
                                      _vm._v("Individual Contributor"),
                                    ]),
                                    _vm._v(" "),
                                    _c("option", { attrs: { disabled: "" } }, [
                                      _vm._v("Manager"),
                                    ]),
                                    _vm._v(" "),
                                    _c("option", { attrs: { disabled: "" } }, [
                                      _vm._v("Senior Manager"),
                                    ]),
                                  ]
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "form-group mx-sm-3 mb-2" },
                              [
                                _c("label", { staticClass: "sr-only" }, [
                                  _vm._v("Scale"),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "select",
                                  {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _setup.inputScaleName,
                                        expression: "inputScaleName",
                                      },
                                    ],
                                    staticClass: "form-control",
                                    on: {
                                      change: function ($event) {
                                        var $$selectedVal =
                                          Array.prototype.filter
                                            .call(
                                              $event.target.options,
                                              function (o) {
                                                return o.selected
                                              }
                                            )
                                            .map(function (o) {
                                              var val =
                                                "_value" in o
                                                  ? o._value
                                                  : o.value
                                              return val
                                            })
                                        _setup.inputScaleName = $event.target
                                          .multiple
                                          ? $$selectedVal
                                          : $$selectedVal[0]
                                      },
                                    },
                                  },
                                  [_c("option", [_vm._v("Default scale")])]
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "button",
                              {
                                staticClass: "btn btn-primary mb-2",
                                attrs: {
                                  type: "button",
                                  disabled:
                                    _setup.invokingUpdatePersonCommandV1,
                                },
                                on: { click: _setup.handleUpdatePerson },
                              },
                              [_vm._v("Update person")]
                            ),
                            _vm._v(" "),
                            _c(
                              "svg",
                              {
                                staticClass: "bi bi-x",
                                staticStyle: { "margin-left": "30px" },
                                attrs: {
                                  width: "3em",
                                  height: "3em",
                                  viewBox: "0 0 16 16",
                                  fill: "currentColor",
                                  xmlns: "http://www.w3.org/2000/svg",
                                },
                                on: {
                                  click: function ($event) {
                                    _setup.inputSubMenu = null
                                  },
                                },
                              },
                              [
                                _c("path", {
                                  attrs: {
                                    "fill-rule": "evenodd",
                                    d: "M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z",
                                  },
                                }),
                              ]
                            ),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _setup.inputSubMenu != "VotingCycle" &&
                      _setup.regionModel.VotingCycle &&
                      !_setup.regionModel.VotingCycleStarted
                        ? _c(
                            "div",
                            {
                              staticClass: "alert alert-warning",
                              attrs: { role: "alert" },
                            },
                            [
                              _vm._v(
                                "\n                        Voting is disabled now which means that people can not open their surveys. To change it click\n                        "
                              ),
                              _c(
                                "a",
                                {
                                  staticClass: "pointer",
                                  attrs: { title: "Manage voting cycles" },
                                  on: {
                                    click: function ($event) {
                                      _setup.inputSubMenu = "VotingCycle"
                                    },
                                  },
                                },
                                [_c("strong", [_vm._v("here")])]
                              ),
                              _vm._v(".\n                    "),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _setup.inputSubMenu == "VotingCycle"
                        ? _c(
                            "div",
                            [
                              _vm._l(
                                _setup.regionModel.VotingCycles,
                                function (vc) {
                                  return [
                                    vc == _setup.regionModel.VotingCycle
                                      ? _c(
                                          "div",
                                          {
                                            staticClass: "dropdown",
                                            staticStyle: {
                                              display: "inline-block",
                                            },
                                          },
                                          [
                                            _c(
                                              "button",
                                              {
                                                staticClass:
                                                  "btn btn-warning dropdown-toggle",
                                                staticStyle: {
                                                  display: "inline-block",
                                                  "margin-right": "3px",
                                                },
                                                attrs: {
                                                  type: "button",
                                                  "data-toggle": "dropdown",
                                                },
                                              },
                                              [
                                                _c("span", [
                                                  _vm._v(_vm._s(vc)),
                                                ]),
                                                _vm._v(" "),
                                                _setup.regionModel
                                                  .VotingCycleStarted
                                                  ? _c("span", [
                                                      _vm._v(" (started)"),
                                                    ])
                                                  : _c("span", [
                                                      _vm._v(" (stopped)"),
                                                    ]),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              { staticClass: "dropdown-menu" },
                                              [
                                                _setup.regionModel
                                                  .VotingCycleStarted
                                                  ? _c(
                                                      "a",
                                                      {
                                                        staticClass:
                                                          "dropdown-item",
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            return _setup.handleStopVotingCycle(
                                                              vc
                                                            )
                                                          },
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          "Stop current voting"
                                                        ),
                                                      ]
                                                    )
                                                  : _c(
                                                      "a",
                                                      {
                                                        staticClass:
                                                          "dropdown-item",
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            return _setup.handleStartVotingCycle(
                                                              vc
                                                            )
                                                          },
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          "Start current voting"
                                                        ),
                                                      ]
                                                    ),
                                              ]
                                            ),
                                          ]
                                        )
                                      : _c(
                                          "div",
                                          {
                                            staticClass: "dropdown",
                                            staticStyle: {
                                              display: "inline-block",
                                            },
                                          },
                                          [
                                            _c(
                                              "button",
                                              {
                                                staticClass:
                                                  "btn btn-secondary dropdown-toggle",
                                                staticStyle: {
                                                  display: "inline-block",
                                                  "margin-right": "3px",
                                                },
                                                attrs: {
                                                  type: "button",
                                                  "data-toggle": "dropdown",
                                                },
                                              },
                                              [_c("span", [_vm._v(_vm._s(vc))])]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              { staticClass: "dropdown-menu" },
                                              [
                                                _c(
                                                  "a",
                                                  {
                                                    staticClass:
                                                      "dropdown-item",
                                                    on: {
                                                      click: function ($event) {
                                                        return _setup.handleSwitchVotingCycle(
                                                          vc
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [_vm._v("Switch to")]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "a",
                                                  {
                                                    staticClass:
                                                      "dropdown-item",
                                                    on: {
                                                      click: function ($event) {
                                                        return _setup.handleRemoveVotingCycle(
                                                          vc
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [_vm._v("Delete")]
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                  ]
                                }
                              ),
                              _vm._v(" "),
                              _c(
                                "button",
                                {
                                  staticClass: "btn btn-success",
                                  attrs: { type: "button" },
                                  on: { click: _setup.handleAddVotingCycle },
                                },
                                [_vm._v("Add voting cycle...")]
                              ),
                              _vm._v(" "),
                              _c(
                                "svg",
                                {
                                  staticClass: "bi bi-x",
                                  staticStyle: { "margin-left": "30px" },
                                  attrs: {
                                    width: "3em",
                                    height: "3em",
                                    viewBox: "0 0 16 16",
                                    fill: "currentColor",
                                    xmlns: "http://www.w3.org/2000/svg",
                                  },
                                  on: {
                                    click: function ($event) {
                                      _setup.inputSubMenu = null
                                    },
                                  },
                                },
                                [
                                  _c("path", {
                                    attrs: {
                                      "fill-rule": "evenodd",
                                      d: "M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z",
                                    },
                                  }),
                                ]
                              ),
                            ],
                            2
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _setup.activePeople.length > 0
                        ? _c("div", [
                            _c(
                              "div",
                              { staticClass: "form-check form-check-inline" },
                              [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _setup.inputShowDeletedUsers,
                                      expression: "inputShowDeletedUsers",
                                    },
                                  ],
                                  staticClass: "form-check-input",
                                  attrs: {
                                    type: "checkbox",
                                    id: "showDeletedUsers",
                                  },
                                  domProps: {
                                    checked: Array.isArray(
                                      _setup.inputShowDeletedUsers
                                    )
                                      ? _vm._i(
                                          _setup.inputShowDeletedUsers,
                                          null
                                        ) > -1
                                      : _setup.inputShowDeletedUsers,
                                  },
                                  on: {
                                    change: function ($event) {
                                      var $$a = _setup.inputShowDeletedUsers,
                                        $$el = $event.target,
                                        $$c = $$el.checked ? true : false
                                      if (Array.isArray($$a)) {
                                        var $$v = null,
                                          $$i = _vm._i($$a, $$v)
                                        if ($$el.checked) {
                                          $$i < 0 &&
                                            (_setup.inputShowDeletedUsers =
                                              $$a.concat([$$v]))
                                        } else {
                                          $$i > -1 &&
                                            (_setup.inputShowDeletedUsers = $$a
                                              .slice(0, $$i)
                                              .concat($$a.slice($$i + 1)))
                                        }
                                      } else {
                                        _setup.inputShowDeletedUsers = $$c
                                      }
                                    },
                                  },
                                }),
                                _vm._v(" "),
                                _c(
                                  "label",
                                  {
                                    staticClass: "form-check-label",
                                    attrs: { for: "showDeletedUsers" },
                                  },
                                  [_vm._v("Show disabled users")]
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "table",
                              {
                                staticClass: "table table-striped",
                                staticStyle: { "margin-top": "20px" },
                              },
                              [
                                _c("thead", [
                                  _c("tr", [
                                    _c(
                                      "th",
                                      {
                                        staticStyle: { width: "20px" },
                                        attrs: { scope: "col" },
                                      },
                                      [
                                        _c(
                                          "button",
                                          {
                                            staticClass: "btn btn-light btn-sm",
                                            attrs: { type: "button" },
                                            on: {
                                              click:
                                                _setup.handleTooglePeopleSelection,
                                            },
                                          },
                                          [
                                            _c(
                                              "svg",
                                              {
                                                staticClass: "bi bi-check2-all",
                                                attrs: {
                                                  width: "1em",
                                                  height: "1em",
                                                  viewBox: "0 0 16 16",
                                                  fill: "currentColor",
                                                  xmlns:
                                                    "http://www.w3.org/2000/svg",
                                                },
                                              },
                                              [
                                                _c("path", {
                                                  attrs: {
                                                    "fill-rule": "evenodd",
                                                    d: "M12.354 3.646a.5.5 0 0 1 0 .708l-7 7a.5.5 0 0 1-.708 0l-3.5-3.5a.5.5 0 1 1 .708-.708L5 10.293l6.646-6.647a.5.5 0 0 1 .708 0z",
                                                  },
                                                }),
                                                _vm._v(" "),
                                                _c("path", {
                                                  attrs: {
                                                    d: "M6.25 8.043l-.896-.897a.5.5 0 1 0-.708.708l.897.896.707-.707zm1 2.414l.896.897a.5.5 0 0 0 .708 0l7-7a.5.5 0 0 0-.708-.708L8.5 10.293l-.543-.543-.707.707z",
                                                  },
                                                }),
                                              ]
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c("th", { attrs: { scope: "col" } }, [
                                      _vm._v("Email"),
                                    ]),
                                    _vm._v(" "),
                                    _c("th", { attrs: { scope: "col" } }, [
                                      _vm._v("Display name"),
                                    ]),
                                    _vm._v(" "),
                                    _c("th", { attrs: { scope: "col" } }, [
                                      _vm._v("Assigned criteria"),
                                    ]),
                                    _vm._v(" "),
                                    _c("th", { attrs: { scope: "col" } }, [
                                      _c("span", [_vm._v("Progress")]),
                                      _vm._v(" "),
                                      _c(
                                        "a",
                                        {
                                          staticClass: "pointer",
                                          attrs: { title: "Refresh progress" },
                                          on: {
                                            click: _setup.handleRefreshProgress,
                                          },
                                        },
                                        [
                                          _c(
                                            "svg",
                                            {
                                              staticClass:
                                                "bi bi-arrow-clockwise",
                                              attrs: {
                                                width: "1em",
                                                height: "1em",
                                                viewBox: "0 0 16 16",
                                                fill: "currentColor",
                                                xmlns:
                                                  "http://www.w3.org/2000/svg",
                                              },
                                            },
                                            [
                                              _c("path", {
                                                attrs: {
                                                  "fill-rule": "evenodd",
                                                  d: "M8 3a5 5 0 1 0 4.546 2.914.5.5 0 0 1 .908-.417A6 6 0 1 1 8 2v1z",
                                                },
                                              }),
                                              _vm._v(" "),
                                              _c("path", {
                                                attrs: {
                                                  d: "M8 4.466V.534a.25.25 0 0 1 .41-.192l2.36 1.966c.12.1.12.284 0 .384L8.41 4.658A.25.25 0 0 1 8 4.466z",
                                                },
                                              }),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ]),
                                  ]),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "tbody",
                                  _vm._l(
                                    _setup.peopleWithProgress,
                                    function (p, i) {
                                      return _c("tr", { key: p.Email }, [
                                        _c("th", { attrs: { scope: "row" } }, [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "form-group form-check",
                                            },
                                            [
                                              _c("input", {
                                                directives: [
                                                  {
                                                    name: "model",
                                                    rawName: "v-model",
                                                    value:
                                                      _setup.inputSelectedPeople,
                                                    expression:
                                                      "inputSelectedPeople",
                                                  },
                                                ],
                                                staticClass: "form-check-input",
                                                attrs: {
                                                  disabled: !p.Enabled,
                                                  type: "checkbox",
                                                },
                                                domProps: {
                                                  value: p.Id,
                                                  checked: Array.isArray(
                                                    _setup.inputSelectedPeople
                                                  )
                                                    ? _vm._i(
                                                        _setup.inputSelectedPeople,
                                                        p.Id
                                                      ) > -1
                                                    : _setup.inputSelectedPeople,
                                                },
                                                on: {
                                                  change: function ($event) {
                                                    var $$a =
                                                        _setup.inputSelectedPeople,
                                                      $$el = $event.target,
                                                      $$c = $$el.checked
                                                        ? true
                                                        : false
                                                    if (Array.isArray($$a)) {
                                                      var $$v = p.Id,
                                                        $$i = _vm._i($$a, $$v)
                                                      if ($$el.checked) {
                                                        $$i < 0 &&
                                                          (_setup.inputSelectedPeople =
                                                            $$a.concat([$$v]))
                                                      } else {
                                                        $$i > -1 &&
                                                          (_setup.inputSelectedPeople =
                                                            $$a
                                                              .slice(0, $$i)
                                                              .concat(
                                                                $$a.slice(
                                                                  $$i + 1
                                                                )
                                                              ))
                                                      }
                                                    } else {
                                                      _setup.inputSelectedPeople =
                                                        $$c
                                                    }
                                                  },
                                                },
                                              }),
                                            ]
                                          ),
                                        ]),
                                        _vm._v(" "),
                                        _c("td", [
                                          _c(
                                            "div",
                                            { staticClass: "btn-group" },
                                            [
                                              _c(
                                                "a",
                                                {
                                                  staticClass: "btn btn-sm",
                                                  attrs: {
                                                    type: "button",
                                                    "data-toggle": "dropdown",
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "svg",
                                                    {
                                                      staticClass:
                                                        "bi bi-menu-app-fill",
                                                      attrs: {
                                                        width: "1em",
                                                        height: "1em",
                                                        viewBox: "0 0 16 16",
                                                        fill: "currentColor",
                                                        xmlns:
                                                          "http://www.w3.org/2000/svg",
                                                      },
                                                    },
                                                    [
                                                      _c("path", {
                                                        attrs: {
                                                          "fill-rule":
                                                            "evenodd",
                                                          d: "M0 1.5A1.5 1.5 0 0 1 1.5 0h2A1.5 1.5 0 0 1 5 1.5v2A1.5 1.5 0 0 1 3.5 5h-2A1.5 1.5 0 0 1 0 3.5v-2zM14 7H2a1 1 0 0 0-1 1v5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V8a1 1 0 0 0-1-1zM2 6a2 2 0 0 0-2 2v5a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2H2z",
                                                        },
                                                      }),
                                                      _vm._v(" "),
                                                      _c("path", {
                                                        attrs: {
                                                          "fill-rule":
                                                            "evenodd",
                                                          d: "M15 11H1v-1h14v1zM2 12.5a.5.5 0 0 1 .5-.5h6a.5.5 0 0 1 0 1h-6a.5.5 0 0 1-.5-.5zm0-4a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1-.5-.5z",
                                                        },
                                                      }),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass: "dropdown-menu",
                                                },
                                                [
                                                  _c(
                                                    "h6",
                                                    {
                                                      staticClass:
                                                        "dropdown-header",
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(p.DisplayName)
                                                      ),
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c("div", {
                                                    staticClass:
                                                      "dropdown-divider",
                                                  }),
                                                  _vm._v(" "),
                                                  _c(
                                                    "a",
                                                    {
                                                      directives: [
                                                        {
                                                          name: "sanitizedHref",
                                                          rawName:
                                                            "v-sanitizedHref",
                                                          value: `/#/rankhr/individualreport/${p.Id}/${_setup.encodedVotingCycle}`,
                                                          expression:
                                                            "`/#/rankhr/individualreport/${p.Id}/${encodedVotingCycle}`",
                                                        },
                                                      ],
                                                      key: `${p.Id}_${_setup.encodedVotingCycle}`,
                                                      staticClass:
                                                        "dropdown-item",
                                                      attrs: {
                                                        target: "_blank",
                                                      },
                                                    },
                                                    [_vm._v("Open report")]
                                                  ),
                                                  _vm._v(" "),
                                                  p.Enabled
                                                    ? _c(
                                                        "a",
                                                        {
                                                          staticClass:
                                                            "dropdown-item",
                                                          on: {
                                                            click: function (
                                                              $event
                                                            ) {
                                                              return _setup.handleEditPerson(
                                                                p
                                                              )
                                                            },
                                                          },
                                                        },
                                                        [_vm._v("Edit")]
                                                      )
                                                    : _vm._e(),
                                                  _vm._v(" "),
                                                  p.Enabled
                                                    ? _c(
                                                        "a",
                                                        {
                                                          staticClass:
                                                            "dropdown-item",
                                                          on: {
                                                            click: function (
                                                              $event
                                                            ) {
                                                              return _setup.handleDisablePerson(
                                                                p.Id
                                                              )
                                                            },
                                                          },
                                                        },
                                                        [_vm._v("Disable")]
                                                      )
                                                    : _vm._e(),
                                                  _vm._v(" "),
                                                  !p.Enabled
                                                    ? _c(
                                                        "a",
                                                        {
                                                          staticClass:
                                                            "dropdown-item",
                                                          on: {
                                                            click: function (
                                                              $event
                                                            ) {
                                                              return _setup.handleEnablePerson(
                                                                p.Id
                                                              )
                                                            },
                                                          },
                                                        },
                                                        [_vm._v("Enable")]
                                                      )
                                                    : _vm._e(),
                                                ]
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "span",
                                            {
                                              class: {
                                                "person-disabled": !p.Enabled,
                                              },
                                            },
                                            [_vm._v(_vm._s(p.Email))]
                                          ),
                                        ]),
                                        _vm._v(" "),
                                        _c("td", [
                                          _vm._v(_vm._s(p.DisplayName)),
                                        ]),
                                        _vm._v(" "),
                                        _c("td", [
                                          _vm._v(_vm._s(p.CriteriaName)),
                                        ]),
                                        _vm._v(" "),
                                        _c("td", [
                                          _c(
                                            "a",
                                            {
                                              directives: [
                                                {
                                                  name: "sanitizedHref",
                                                  rawName: "v-sanitizedHref",
                                                  value: `/#/rankhr/survey/${p.Id}`,
                                                  expression:
                                                    "`/#/rankhr/survey/${p.Id}`",
                                                },
                                              ],
                                              attrs: { target: "_blank" },
                                            },
                                            [_vm._v(_vm._s(p.Progress) + "%")]
                                          ),
                                        ]),
                                      ])
                                    }
                                  ),
                                  0
                                ),
                              ]
                            ),
                          ])
                        : _vm._e(),
                    ])
                  : _c("div", { staticStyle: { margin: "30px" } }, [
                      _c("h2", [
                        _vm._v("It seems that region is not configured yet..."),
                      ]),
                      _vm._v(" "),
                      _c("form", { staticClass: "form-inline" }, [
                        _c("div", { staticClass: "form-group mb-2" }, [
                          _c("label", { staticClass: "sr-only" }, [
                            _vm._v("Region name"),
                          ]),
                          _vm._v(" "),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _setup.inputRegionName,
                                expression: "inputRegionName",
                              },
                            ],
                            staticClass: "form-control",
                            attrs: {
                              type: "email",
                              placeholder: "Region name",
                            },
                            domProps: { value: _setup.inputRegionName },
                            on: {
                              input: function ($event) {
                                if ($event.target.composing) return
                                _setup.inputRegionName = $event.target.value
                              },
                            },
                          }),
                          _vm._v(" "),
                          _c("div", { staticClass: "valid-feedback" }, [
                            _vm._v(
                              "\n                                Looks good!\n                            "
                            ),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            staticClass: "btn btn-primary mb-2",
                            attrs: { type: "button" },
                            on: { click: _setup.handleCreateRegion },
                          },
                          [_vm._v("Create region")]
                        ),
                      ]),
                    ]),
              ]),
            ]),
          ]
        ),
      ])
    : _vm._e()
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c(
      "button",
      {
        staticClass: "btn btn-secondary",
        attrs: {
          type: "button",
          "data-toggle": "dropdown",
          "aria-haspopup": "true",
          "aria-expanded": "false",
        },
      },
      [_c("i", { staticClass: "fa fa-cog", attrs: { "aria-hidden": "true" } })]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c(
      "a",
      {
        staticClass: "btn btn-light",
        attrs: {
          href: "https://www.transparentchoice.com/mmb",
          target: "_blank",
        },
      },
      [_c("span", { staticClass: "fa fa-info" })]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }